import React from 'react';

export default function CardHeaderLeftUnexpectedAppointment() {
  return (
    <div className="est-name">
      <div className="encounter-name">Unexpected Encounter</div>
    </div>
  );
}
